/**
 * OnboardingBackdrop — анимированный премиум фон для всего онбординга.
 *
 * Три слоя:
 *   1. Базовый deep-space gradient (фиксированный, тёмный)
 *   2. Conic gradient mesh — 4 лунных точки, медленный rotate 40с
 *   3. Noise overlay — 4% opacity, blend 'soft-light', статический
 *
 * Все три слоя composited через absolute positioning. Noise-SVG —
 * data-URL чтобы не тянуть внешний файл.
 */
import { motion } from 'motion/react';

const NOISE_SVG = encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120'>
    <filter id='n'><feTurbulence type='fractalNoise' baseFrequency='1.3' numOctaves='2' stitchTiles='stitch'/></filter>
    <rect width='100%' height='100%' filter='url(#n)' opacity='1'/>
  </svg>`,
);

export function OnboardingBackdrop() {
  return (
    <>
      {/* 1. Deep space base */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(120% 100% at 50% 0%, rgba(28,32,58,1) 0%, rgba(12,14,28,1) 50%, rgba(6,7,14,1) 100%)',
        }}
      />

      {/* 2. Conic gradient mesh — 4 лунных цветовых точки */}
      <motion.div
        className="absolute inset-[-20%]"
        style={{
          background:
            'conic-gradient(from 0deg at 50% 50%, ' +
            'rgba(90,120,200,0.22) 0deg, ' +
            'rgba(140,100,220,0.14) 90deg, ' +
            'rgba(60,170,200,0.20) 180deg, ' +
            'rgba(180,150,220,0.12) 270deg, ' +
            'rgba(90,120,200,0.22) 360deg)',
          filter: 'blur(80px)',
          willChange: 'transform',
        }}
        animate={{ rotate: 360 }}
        transition={{
          duration: 40,
          ease: 'linear',
          repeat: Infinity,
        }}
      />

      {/* 3. Noise overlay — soft-light, статический */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml;utf8,${NOISE_SVG}")`,
          backgroundSize: '120px 120px',
          opacity: 0.04,
          mixBlendMode: 'soft-light',
        }}
      />

      {/* 4. Нежный vignette по краям */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(120% 80% at 50% 50%, transparent 40%, rgba(0,0,0,0.5) 100%)',
        }}
      />
    </>
  );
}
